<template>
  <b-container fluid>
    <div>
      <BaseFacilitySelect
        :is-picked-facility="true"
      ></BaseFacilitySelect>
    </div>
    <div>
      <div class="card">
        <div class="card-header">
          <strong>User management: Account verification</strong>
        </div>
        <div class="card-body">
          <div>
            <b-row cols-sm="4">
              <b-col>
                <label for="firstName"><strong>Email:</strong></label><br/>
                <b-form-input
                  id="email"
                  setId="email"
                  v-model="search.email"
                  :v="search.email"
                  slug="email"
                  label="email"
                  placeholder="Email address"
                >
                </b-form-input>
              </b-col>
              <b-col class="mt-auto">
                <b-button class="lg" id="searchButton" variant="secondary" @click="clear" role="button">Clear</b-button>
              </b-col>
            </b-row>
            <b-row cols-lg="4">
              <b-col class="mt-auto">
                <b-button class="d-block p-2 bg-mdh text-white" id="searchButton" @click="searchUsers" role="button">Search</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <div>
      <b-modal id="user-found-modal" hide-header hide-footer>
        <h2>VaxCheck account verification result</h2>
        <hr/>
        <p>Email address: {{this.search.email}}<br>
          Is associated with {{users.firstName}} {{users.lastName}}
        </p>
        <p class="mt-2">Do you want to provide them access to the following facility: {{this.$store.state.selectedFacility.facilityName}}</p>
        <form ref="form" @submit.prevent="addFacility()">
          <div>
            <b-button @click="closeUserFoundModal" style="margin-right:15px;">Back to search page</b-button>
            <b-button type="submit" class="bg-mdh">Yes</b-button>
          </div>
        </form>

      </b-modal>
    </div>
    <div>
      <b-modal id="user-in-facility-modal" hide-header hide-footer>
        <h2>VaxCheck account verification result</h2>
        <hr/>
        <p>Email address: {{this.search.email}}<br>
          Is associated with {{users.firstName}} {{users.lastName}}
        </p>
        <p class="mt-2">They are already part of selected facility: {{this.$store.state.selectedFacility.facilityName}}</p>
        <form ref="form" >
          <div>
            <b-button @click="closeInFacilityModal" style="margin-right:15px;">Back to search page</b-button>
          </div>
        </form>

      </b-modal>
    </div>
    <div>
      <b-modal id="user-wrong-org-modal" hide-header hide-footer>
        <h2>VaxCheck account verification result</h2>
        <hr/>
        <p>Email address: {{this.search.email}}<br>
          Is associated with a user from a different organization and cannot be added to this one.
        </p>
        <form ref="form" >
          <div>
            <b-button @click="closeWrongOrgModal" style="margin-right:15px;">Back to search page</b-button>
          </div>
        </form>

      </b-modal>
    </div>
    <div>
      <b-modal id="user-not-found-modal" hide-header hide-footer>
        <h2>VaxCheck account verification result</h2>
        <hr/>
        <p>Email address: {{this.search.email}}<br>
          Is not associated with any existing user account.
        </p>
        <p class="mt-2">Do you want create a new user account?</p>
        <div>
          <b-button @click="closeUserNotFoundModal" style="margin-right:15px;">Back to search page</b-button>
          <b-button type="submit" class="bg-mdh" @click="pushAddUserPage">Yes</b-button>
        </div>
      </b-modal>
    </div>
  </b-container>
</template>


<script>
import {email} from "vuelidate/lib/validators";
import axios from "axios";
import router from "@/router";
import BaseFacilitySelect from "@/components/templates/input/BaseFacilitySelect.vue";

export default {
  components: {BaseFacilitySelect},
  data: () => ({
    search: {
      email: '',
    },
    users: '',
    searched: false,

  }),

  watch: {
    'search.email'(email) {
      this.search.email = email.toLowerCase().trim()
    }
  },

  methods: {
    clear() {
      this.search.email = ''
      this.users = ''
    },
    searchUsers() {
      this.users = ''
      if (this.search.email.toLowerCase().trim().length > 0) {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/${this.search.email.toLowerCase().trim()}`, {validateStatus: function (status) {
          return status === 200 || status === 400;} // Resolve only if the status code is less than 500
          })
          .then(response => {
            if (response.data && response.data.emailAddress === this.search.email.toLowerCase().trim()) {
              this.users = response.data;
              if(this.users.org.id === this.$store.state.selectedFacility.org.id){
                if(this.inCurrentFacility()){
                  this.$bvModal.show('user-in-facility-modal')
                }
                else{
                  this.$bvModal.show('user-found-modal')
                }
              }
              else {
                this.$bvModal.show('user-wrong-org-modal')
              }
            } else {
              this.$bvModal.show('user-not-found-modal')
            }

            }).catch(error => {
              if (error.response) {
                if(error.response.status === 404) {
                  console.log('BAD URL')
                  console.log(error)
                  console.log('not found')
                }
              }

            })
      }
    },
    addFacility() {
      let facilityId = this.$store.state.selectedFacility.id
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/user/addFacility`, this.users, {params: {facilityId}})
        .then(response => {
          if (response.status === 200) {
            this.showRootToast('Success','User added to facility.', 'success')
            this.closeUserFoundModal()
            router.push('userManagementSearch')
          }
        }).catch(error => {
          this.showRootToast('Error','Error adding user to facility.', 'danger')
        })
    },
    inCurrentFacility(){
      for (let i = 0; i < this.users.facilities.length; i++) {
        if(this.users.facilities[i].id === this.$store.state.selectedFacility.id)
          return true
      }
      return false
    },
    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
    pushAddUserPage() {
      router.push({name: 'userManagementAdd', params: {email: this.search.email}})
    },
    closeUserFoundModal() {
      this.$bvModal.hide('user-found-modal')
    },
    closeInFacilityModal(){
      this.$bvModal.hide('user-in-facility-modal')
    },
    closeWrongOrgModal(){
      this.$bvModal.hide('user-wrong-org-modal')
    },
    closeUserNotFoundModal() {
      this.$bvModal.hide('user-not-found-modal')
    },
  },

}

</script>


<style scoped>

</style>
